// extracted by mini-css-extract-plugin
export default {"content":"SectionHeader_content__K1uSb"};